import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityUptimeMonitorsDashboardSlice } from './get';

export const coreDataSecurityUptimeMonitorsDashboardReducers = combineReducers({
	get: getCoreDataSecurityUptimeMonitorsDashboardSlice.asyncReducers
});

export const coreDataSecurityUptimeMonitorsDashboardWatchers = combineAllWatchers([
	getCoreDataSecurityUptimeMonitorsDashboardSlice.asyncWatchers
]);
